import Terms from "components/account/ProfileInputs/Terms";

export default () => {
  return (
    <div className="termsPage">
      <Terms />
    </div>
  );
};
